module.exports = __webpack_public_path__ + "img/half-star-1.adc497cd.svg";